import { createContext, useContext, useState } from 'react';

/**
 * Which wing the visitor is pointing at: 'work', 'life', or 'none'.
 *
 * Shared above the router so every doorway into a wing — the navbar
 * switch, the balance pans, the door cards — can tip the same beam.
 */
const LeanContext = createContext(null);

export const LeanProvider = ({ children }) => {
  const [lean, setLean] = useState('none');
  return (
    <LeanContext.Provider value={{ lean, setLean }}>
      {children}
    </LeanContext.Provider>
  );
};

/* Falls back to local state when no provider is mounted, so HomePage
   still leans on its own in standalone renders (tests). */
export const useLean = () => {
  const shared = useContext(LeanContext);
  const [lean, setLean] = useState('none');
  return shared ?? { lean, setLean };
};
